// extracted by mini-css-extract-plugin
export default {"container":"Aboutus_container__b++6B","left":"Aboutus_left__iLA2W","right":"Aboutus_right__cvAUD"};